import { CommonStatusTag } from 'components/CommonStatusTag';

import { colors } from 'constants/colors';

import { UserState } from 'data/__generated__';
import { USER_STATES_LABELS } from '../constants/states';

const getColorsFromState = (state: UserState) => {
    const { green, yellow, red, pantinGrey, darkGrey, black, pureWhite } = colors;

    switch (state) {
        case UserState.Regular:
            return { backgroundColor: green, labelColor: black };
        case UserState.Created:
        case UserState.OnBoarding:
        case UserState.AddedToTeam:
            return { backgroundColor: yellow, labelColor: black };
        case UserState.Banned:
            return { backgroundColor: red, labelColor: pureWhite };
        case UserState.Archived:
            return { backgroundColor: pantinGrey, labelColor: pureWhite };
        case UserState.Deleted:
            return { backgroundColor: darkGrey, labelColor: pureWhite };
    }
};

export const StatusTag = ({ state, showHeading }: { state: UserState; showHeading?: boolean }) => {
    const { backgroundColor, labelColor } = getColorsFromState(state);
    return (
        <CommonStatusTag
            backgroundColor={backgroundColor}
            labelColor={labelColor}
            label={USER_STATES_LABELS[state]}
            showHeading={showHeading}
        />
    );
};
